const towed_trailer_header = [
            { title: "Tires, wheels, stem caps", description: "Inflation, leaks, damage, wear" },
            { title: "Brakes", description: "Inoprative" },
            { title: "Coupling devices", description: "Damaged or insecure" },
            { title: "Doors", description: "Damaged" },
            { title: "Landing gear/trailer jacks", description: "Function, damage" },
            { title: "Reflectors/reflective tape", description: "Presend, damage" },
            { title: "Roof", description: "Condition" },
            { title: "Suspension system", description: "Damage or deterioration" },
            { title: "Hitch", description: "Damaged or insecure" },
            { title: "Safety chains", description: "Damage or deterioration" },
            { title: "Lights, tail", description: "Function, damage" },
            { title: "Lights, turn indicators", description: "Function, damage" },
            { title: "Straps", description: "Function, damage" },
            { title: "Tarp", description: "Condition" },
            { title: "Tires", description: "Inflation, tread, damage" },
            { title: "Wheels, rims, lugs", description: "Loose, missing, damaged or ineffective wheel faster" },
        ]
        
export default towed_trailer_header;